import React from 'react';
import { T } from '../../utils/adminTheme';

interface LoadingSpinnerProps {
  label?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: 16 }}>
    <div style={{
      width: 28,
      height: 28,
      borderRadius: '50%',
      border: `2.5px solid ${T.line}`,
      borderTopColor: T.accent,
      animation: 'spin 0.75s linear infinite',
    }} />
    {label && <span style={{ fontFamily: T.body, fontSize: 13, color: T.muted }}>{label}</span>}
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default LoadingSpinner;
